import { forwardRef } from "react";
import { InPlaceDropDownEditor } from "@etframework/ui.components";
import { SkeletonComponent } from "@syncfusion/ej2-react-notifications";
import { useTranslation } from "react-i18next";

export const UsersDropdownInPlaceEditor = forwardRef(
  (
    { id, value, actionSuccess, boardPermissions, loading, change, ...rest },
    ref
  ) => {
    const users = boardPermissions?.Entities;
    const { t } = useTranslation(["Overlay"]);

    var defaultValue = users?.find((x) => x.Id == value) ? value : null;

    return loading ? (
      <SkeletonComponent
        height={"1.5em"}
        className="my-1"
        shimmerEffect="Fade"
      />
    ) : (
      <InPlaceDropDownEditor
        ref={ref}
        id={id}
        name={id}
        value={
          loading ? null : defaultValue
        } /* Prevent showing ID as display value */
        fields={{ text: "FullName", value: "Id" }}
        dataSource={users?.filter((x) => x.FullName) ?? []}
        placeholder={t("AssigneePlaceholder")}
        disabled={loading}
        actionSuccess={actionSuccess}
        model={{ showClearButton: false }}
        change={change}
        sortOrder="Ascending"
        {...rest}
      />
    );
  }
);
